export const selectIsDraw = (state) => state.isDraw;
